// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d0d7cd99","455":"beb09b95","977":"546aec64"}[chunkId] + ".chunk.js";
};